import { render } from "./AccountBonusesPage.vue?vue&type=template&id=70a783c5&scoped=true"
import script from "./AccountBonusesPage.vue?vue&type=script&lang=ts"
export * from "./AccountBonusesPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-70a783c5"

export default script